export default {
  setIdSurvey(state, survey_id) {
    state.SurveyForm_id = survey_id;
  },
  clearSurveyData(state) {
    state.SurveyForm_id = null;
  },
};
